module.exports = __webpack_public_path__ + "static/media/planetTexture2.334ae6c3.jpeg";